import React from 'react';

// Ported verbatim from Klargo-Reference's OverviewAtmosphere.tsx: a static,
// aria-hidden, pointer-events-none decorative layer of cropped record
// fragments behind the ChooseAction panels. No animation, so it needs no
// reduced-motion handling of its own.
const GhostRecord = ({ className }) => (
  <div
    className={`absolute rounded-[20px] border border-[rgba(11,122,85,.046)] ${className ?? ''}`}
    style={{
      background:
        'linear-gradient(158deg, rgba(255,255,255,.38), rgba(255,255,255,.12) 56%, rgba(11,122,85,.012) 92%)',
      boxShadow: '0 44px 84px -66px rgba(16,30,40,.11)',
    }}
  />
);

const FLOOR_FADE = 'linear-gradient(to bottom, #000 0%, #000 92%, rgba(0,0,0,0) 100%)';

const OverviewAtmosphere = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none absolute inset-x-0 bottom-[-64px] top-0 overflow-hidden"
    style={{ maskImage: FLOOR_FADE, WebkitMaskImage: FLOOR_FADE }}
  >
    <GhostRecord className="bottom-[-130px] left-[-230px] hidden h-[240px] w-[400px] rotate-[5deg] md:block" />

    <div className="relative mx-auto h-full w-full max-w-[1280px]">
      <div
        className="absolute right-[-680px] top-0 hidden h-[760px] w-[1000px] xl:block"
        style={{
          background:
            'radial-gradient(ellipse 52% 56% at 30% 44%, rgba(11,122,85,.048), rgba(11,122,85,.02) 44%, rgba(11,122,85,0) 78%)',
          maskImage: 'linear-gradient(to right, rgba(0,0,0,0) 0%, #000 11%)',
          WebkitMaskImage: 'linear-gradient(to right, rgba(0,0,0,0) 0%, #000 11%)',
        }}
      />
      <GhostRecord className="right-[-320px] top-[-70px] hidden h-[440px] w-[560px] rotate-[6deg] xl:block" />
      <GhostRecord className="bottom-[-40px] right-[-380px] hidden h-[430px] w-[620px] -rotate-[5deg] xl:block" />
    </div>
  </div>
);

export default OverviewAtmosphere;
